import type { ScoreBreakdown } from '@tailorcast/shared-types';
import { clsx } from 'clsx';
import { ScoreBadge } from './ScoreBadge';
import { ChecklistItemView } from './ChecklistItemView';

interface ScoreBreakdownViewProps {
  data: ScoreBreakdown;
}

export function ScoreBreakdownView({ data }: ScoreBreakdownViewProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <ScoreBadge score={data.overallScore} size="md" />
        <span className="text-sm text-gray-600">{data.overallLabel}</span>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {data.aspects.map((aspect) => (
          <div
            key={aspect.key}
            className={clsx('card p-4', aspect.key === 'seo' && 'border-l-4 border-l-amber-400')}
          >
            <div className="flex items-center justify-between mb-2">
              <h4 className="text-sm font-medium text-gray-900 capitalize">{aspect.key}</h4>
              <ScoreBadge score={aspect.score} />
            </div>
            <p className="text-xs text-gray-500 mb-3">{aspect.summary}</p>
            <div className="space-y-1">
              {aspect.checklist.map((item, idx) => (
                <ChecklistItemView key={idx} item={item} isSeo={aspect.key === 'seo'} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
